import { Button, Grid } from '@material-ui/core';
import React, { useCallback, useContext, useRef } from 'react';

import Dialog from 'Common/Dialog';
import Form, { FormRef } from 'Common/Form/Form';
import TextField from 'Common/Form/TextField';
import { AlertContext } from 'context/alert.context';

import { saveOccupationalSafetyRegistries } from '../../../../../api/hs/occupational-safety-registries /occupational-safety-registries';
import { OccupationalSafetyRegistriesResult } from '../../../../../api/hs/occupational-safety-registries /occupational-safety-registries.result';

interface Props {
  open: boolean;

  onClose(success: boolean): void;

  data: OccupationalSafetyRegistriesResult;

  companyId: string;

  fetch(): void;
}

export default function RegistriesForm({ open, onClose, data, companyId, fetch }: Props) {
  const formRef = useRef<FormRef<Record<string, any>>>();
  const { showMessage } = useContext(AlertContext);
  const submit = useCallback(
    async values => {
      const payload = {
        companyId,
        bookNumber: 0,
        label: values.label,
      };
      try {
        if (!data?.id) {
          await saveOccupationalSafetyRegistries(payload);
          showMessage('Ekleme işlemi başarılı.', 'success', 'info');
          await fetch();
        }
        onClose(true);
      } catch (err) {
        showMessage('İşlem sırasında sorun oluştu.', 'error', 'info');
        onClose(false);
      }
    },
    [onClose, showMessage, data, companyId, fetch]
  );

  return (
    <Dialog color="primary" opened={open} onClose={onClose} title={'Defter ekle'}>
      <Form onSubmit={submit} ref={formRef}>
        <Grid container spacing={1}>
          <Grid item md={12} sm={12} lg={12}>
            <TextField type="text" name="label" label="Defter adı" />
          </Grid>
          <Grid item md={12} className="text-right">
            <Button variant="contained" type="submit" color="secondary" className="mr-2">
              {data?.id ? 'Güncelle' : 'Kaydet'}
            </Button>
            <Button variant="contained" type="button" onClick={onClose.bind(null, false)}>
              Vazgeç
            </Button>
          </Grid>
        </Grid>
      </Form>
    </Dialog>
  );
}
